<template>
  <ul class="a-list-element-actions position-right">
    <li>
      <router-link
        :class="`a-tooltip-primary a-tooltip-left ${elementClass}`"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipEdit')"
        :to="editionRoute"
      >
        <i class="fas fa-pencil-alt"></i>
      </router-link>
    </li>
    <li>
      <a
        :class="`a-tooltip-primary a-tooltip-left ${elementClass}`"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipDuplicate')"
        href="/duplicar"
        @click.prevent="$modal.showModal(modalBodyDuplicate, element)"
      >
        <i class="far fa-copy"></i>
      </a>
    </li>
    <li>
      <a
        class="a-tooltip-primary a-tooltip-left text-color-danger"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipDelete')"
        href="/eliminar"
        @click.prevent="$modal.showModal(modalBodyDelete, element)"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomListElementActionsPrimary',

  props: {
    element: Object,
    position: String
  },

  computed: {
    editionRoute () {
      return this.$route.name === 'assets' ? `/${this.$t('rPaths.asset')}/${this.element.id}/${this.$t('mEditionMenu.asset.card.subject')}` : `/${this.$t('rPaths.product')}/${this.element.id}/${this.$t('mEditionMenu.product.card.subject')}`
    },

    elementClass () {
      return this.$route.name === 'assets' ? 'text-color-assets-primary' : 'text-color-products-primary'
    },

    modalBodyDelete () {
      return this.$route.name === 'assets' ? 'MoleculeFeedAssetsContentModalDelete' : 'MoleculeFeedProductsContentModalDelete'
    },

    modalBodyDuplicate () {
      return this.$route.name === 'assets' ? 'MoleculeFeedAssetsContentModalDuplicate' : 'MoleculeFeedProductsContentModalDuplicate'
    }
  }
}
</script>
